#@export GliveBooking.Presenters.SectionPicker

class GliveBooking.Presenters.SectionPicker extends BookingV2.Presenters.Picker

  module: 'glive-booking'

  toHash: ->
    hash = BookingV2.Presenters.Picker.prototype.toHash.apply(this, arguments)
    if @selected()?
      hash.selectedSection =
        title: @selected().getTitle()
    hash.isTouch = @collection.meta('isTouch')
    hash
